
/**
 * Mini sketch
 * @param {p5} p5
 */
const miniSketch = (p) => {
  const boxW = 180;
  const boxH = boxW * p.sqrt(2);

  // Setup
  p.setup = () => {
    p.createCanvas(400, 400, p.WEBGL);
    p.perspective(p.PI / 3.0, p.width / p.height, 0.1, 1000);
    p.pixelDensity(2);
  };

  // Draw tick
  p.draw = () => {
    p.orbitControl(2, 2, 0);

    // Stlying
    p.clear();
    p.stroke(39);
    p.strokeWeight(6);
    p.fill(249);
    // Box
    p.rotateX(p.HALF_PI);
    p.rotateX(p.frameCount / 200);
    p.rotateY(p.frameCount / 200);
    p.rotateZ(p.frameCount / 200);
    p.box(boxW, boxW * 0.2, boxH);
  };

  // Do nothing as not to interfere with the other script
  p.keyReleased = () => {};
};

const miniSketchStage = new p5(miniSketch, 'mini-sketch');
